/** Ambil nama berkas dari header Content-Disposition; kembalikan `fallback` bila header kosong/tak berisi nama aman. */
export function namaBerkasDariHeader(header: string | null, fallback: string): string {
  const nama = header?.match(/filename="([^"]+)"/i)?.[1]
  if (!nama || /[\\/]/.test(nama)) return fallback
  return nama
}
